import withConfigTransport from '../../services/config-transport/withConfigTransport'
import _VaInfiniteScroll from './VaInfiniteScroll.vue'

export const VaInfiniteScroll = withConfigTransport(_VaInfiniteScroll)
